export enum SettingsOptions {
  profileSettings = 'profileSettings',
}

export interface SettingsModuleProps {
  className?: string;
  testId?: string;
}
